import TtamBidStrategyLabel from './label/index.vue';
import TtamBidStrategyTooltip from './strategy-tooltip/index.vue';
import TtamBidStrategyBidcapSuggestBid from './bidcap-suggest-bid/index.vue';
import TtamBidStrategyBidcapSuggestBidChangeButton from './bidcap-suggest-bid-change-button/index.vue';

import TtamBidStrategySuggestBid from './suggest-bid/index.vue';
import TtamBidStrategyDcTips from './dc-tips/index.vue';
import TtamBidStrategyDcInfo from './dc-info/index.vue';
import TtamBidStrategyVideoViewTips from './video-view-tips/index.vue';
import TtamBidStrategyRadios from './radios/index.vue';
import TtamBidStrategyRoasCheckbox from './roas-checkbox/index.vue';
import TtamBidStrategyRoasTips from './roas-tips/index.vue';
import TtamBidStrategySet from './set/index.vue';
import TtamBidStrategyDeepBidCheckbox from './deep-bid-checkbox/index.vue';
import TtamBidStrategyDeepBidSet from './deep-bid-set/index.vue';
import TtamBidStrategyDeepBidSecondRateReminder from './deep-bid-second-rate-reminder/index.vue';
import TtamBidStrategyLearningPhaseTips from './learning-phase-tips/index.vue';
import TtamBidStrategyOptgoalInappeventTitle from './optgoal-inappevent-title/index.vue';
import TtamBidStrategyOptgoalInstallWithInappeventTitle from './optgoal-install-with-inappevent-title/index.vue';
import TtamBidCapToCostCapTips from './bid-cap-to-cost-cap-tips/index.vue';

import hooks from './hooks';
export default {
  TtamBidStrategyLabel,
  TtamBidStrategyTooltip,
  TtamBidStrategySuggestBid,
  TtamBidStrategyBidcapSuggestBid,
  TtamBidStrategyBidcapSuggestBidChangeButton,
  TtamBidStrategyDcTips,
  TtamBidStrategyDcInfo,
  TtamBidStrategyVideoViewTips,
  TtamBidStrategyRadios,
  TtamBidStrategyRoasCheckbox,
  TtamBidStrategyRoasTips,
  TtamBidStrategySet,
  TtamBidStrategyDeepBidCheckbox,
  TtamBidStrategyDeepBidSet,
  TtamBidStrategyDeepBidSecondRateReminder,
  TtamBidStrategyLearningPhaseTips,
  TtamBidStrategyOptgoalInappeventTitle,
  TtamBidStrategyOptgoalInstallWithInappeventTitle,
  TtamBidCapToCostCapTips,
  ...hooks,
};
